export default __webpack_public_path__ + "static/media/Bracers of Bedlam.4e8de887.jpg";